import { BaseModalComponent } from "../../common/BaseModalComponent";
import { JobCard } from "../../jobs/jobs-list/job-card/JobCard";
import { JobLayout } from "../../jobs/jobs-list/jobs-layout/Job.layout";

export const WorkforceTaskCard = ({ job }) => {
  return (
    <BaseModalComponent
      key={`WorkforceTask-JobCard-${job?.id}`}
      sx={{
        width: { xs: "80%", sm: "75%", md: "90%", lg: "1200px" },
        height: { xs: "90%", sm: "85%", md: "90%", lg: "90%" },
      }}
      modalLabel={`Job #${job?.id || 0}`}
      modalKey={`WorkforceTask-JobCard-${job?.id}`}
      elementTrigger={<JobCard job={job} showWorkforce={false} />}
    >
      <JobLayout job={job} showCalendar={false} />
    </BaseModalComponent>
  );
};
